<template>

<div class="menus-admin">
    <menus
        menuCode="DEALER_WEBSITE_MENUS"
        :showLinkType="true">
    </menus>
    <help-popup :helpLink="{75:'Website Menus', 101:'Website Template: Page Menu and Product Menu', 102:'Website Template: Footer Menu'}" :tours="false"></help-popup>

</div>

</template>

<script>
import HelpPopup from '@/components/HelpPopup.vue'

export default {
    components: {
		'help-popup': HelpPopup
    }
}
</script>

<style lang="scss" scoped>
.popup-wrapper {
	top: -2em;
	right: 1em;
}
</style>